import { StyledTable } from '@/Components/Elements/StyledComponents/Tables';
import React, { Component } from 'react'
import { Box, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-duotone-svg-icons/faSearch'

import LoadingDefault from '../../Elements/Loading/LoadingDefault'

import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
class BrpModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            id: null,
            saving: false,
            showModal: false,
            querystring: this.props.querystring ? this.props.querystring : null,
            results: [],
        }
        this.doLookup = this.doLookup.bind(this)
    }

    doLookup() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        let data = {
            environment_id: this.props.kedo.env().getEnvironmentId(),
            querystring: this.state.querystring,
        }

        api.post('/module/brp/lookup', data)
            .then((response) => {
                this.setState({
                    loading: false,
                    results: response.data.results,
                })
            })
            .catch((error) => {
                this.setState({ loading: false })
            })
    }

    componentDidMount() {
        if (this.props.querystring) {
            this.doLookup()
        }
    }

    generateDialogFooter() {
        return (
            <>
                <StyledButton
                    disabled={this.state.saving}
                    onClick={this.doLookup}
                >
                    <FontAwesomeIcon icon={faSearch} />{' '}
                    {this.props.kedo.t('Search')}
                </StyledButton>
                <StyledButton onClick={this.props.onClose} color={'secondary'}>
                    {this.props.kedo.t('Cancel')}
                </StyledButton>
            </>
        )
    }
    renderResults(items) {
        if (!items || items.length <= 0) {
            return ''
        }
        return (
            <TableContainer component={Paper}>
                <StyledTable size="small" striped>
                    <TableHead>
                        <TableRow>
                            <TableCell>Voornamen</TableCell>
                            <TableCell>Tussenvoegsels</TableCell>
                            <TableCell>Achternaam</TableCell>
                            <TableCell>BSN</TableCell>
                            <TableCell>Geboortedatum</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody
                        sx={{
                        }}
                    >
                        {items.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.voornamen}</TableCell>
                                <TableCell>{item.voorvoegsels}</TableCell>
                                <TableCell>{item.geslachtsnaam}</TableCell>
                                <TableCell>{item.bsn}</TableCell>
                                <TableCell>{item.geboortedatum}</TableCell>
                                <TableCell>
                                    <StyledButton
                                        onClick={() =>
                                            this.props.enrichData(item)
                                        }
                                    >
                                        Gebruik
                                    </StyledButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </TableContainer>
        )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={'Zoek op BSN of postcode gevolgd door huisnummer'}
                onClose={this.props.onClose}
                headerClose={this.props.onClose}
                contentProps={{ dividers: true }}
                actions={this.generateDialogFooter()}
                scroll="paper"
            >
                <Box className="table-responsive">
                    <FormInputLabel>Zoek</FormInputLabel>
                    <TextField
                        name="querystring"
                        value={this.state.querystring}
                        onChange={(e) =>
                            this.setState({ querystring: e.target.value })
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    {this.state.loading ? (
                        <center>
                            <LoadingDefault />
                        </center>
                    ) : null}
                    {this.renderResults(this.state.results)}
                </Box>
            </AppDialog>
        )
    }
}

export default BrpModal
